import { formatTime, parseDatetime } from "./date";
import i18n from "i18next";
import moment from "moment-timezone";

const minutesPerDay = 60 * 24;
const STEP = 15;

// expects a moment.js object (date)
const generateStartTimes = (date, step) => {
	let i = 0;
	const startTimes = [];
	const midnight = date.startOf("day");
	while (i < minutesPerDay) {
		startTimes.push(midnight.clone().minute(i));
		i += step;
	}
	return startTimes;
};

const isWithinInterval = (intervals) => (startTime) =>
	intervals.some((iv) => startTime.isBetween(iv.from, iv.to, "minute", "[)"));

const isInTheFuture = (today) => (time) => today.isBefore(time, "minute");

export const officeHoursToBlocks = (ohs, date) =>
	generateStartTimes(date, STEP)
		.filter(isWithinInterval(ohs))
		.filter(isInTheFuture(moment()))
		.sort((iv0, iv1) => iv0 - iv1)
		.map((iv) => ({ from: iv, to: iv.clone().add(String(STEP), "m") }));

export const exclude = (intervals) => (interval0) =>
	intervals.some(
		(iv) =>
			iv.from.isSameOrAfter(interval0.from) &&
			iv.to.isSameOrBefore(interval0.to)
	)
		? { ...interval0, availables: 0, available: 0 }
		: { ...interval0, availables: 1, available: 1 };

export const addSelected = (selectedTimeBlock) => (timeblock) => ({
	...timeblock,
	selected:
		selectedTimeBlock && timeblock.from.isSame(selectedTimeBlock.from),
});

export const sortAsc = (t0, t1) =>
	moment(t0.from).format("HH:mm") - moment(t1.from).format("HH:mm");

export const addListener = (cb) => (timeblock) => ({
	...timeblock,
	onClick: () => cb(timeblock),
});

export const addLabels = (timeblock) => {
	const hour = timeblock.from.hour();
	const label =
		hour < 19
			? hour < 12
				? i18n.t("booking:morning")
				: i18n.t("booking:afternoon")
			: i18n.t("booking:night");
	return { ...timeblock, label };
};

export const parseTimeblock = (tz) => (timeblock) => {
	const from = parseDatetime(timeblock.from, tz);
	const to = parseDatetime(timeblock.to, tz);
	return { ...timeblock, from, to };
};

export const formatTimeblock = (tz) => (timeblock) => {
	const from = formatTime(timeblock.from, tz);
	const to = formatTime(timeblock.to, tz);
	return { ...timeblock, from, to };
};

export const excludeUnavailables = (tb) =>
	!(tb.availables === 0 || tb.available === 0);

export const groupBy = (key) => (acc, timeblock) => {
	if (!acc[timeblock[key]]) acc[timeblock[key]] = [];
	acc[timeblock[key]].push(timeblock);
	return acc;
};

if (!Object.entries) {
	Object.entries = function (obj) {
		var ownProps = Object.keys(obj),
			i = ownProps.length,
			resArray = new Array(i); // preallocate the Array
		while (i--) resArray[i] = [ownProps[i], obj[ownProps[i]]];

		return resArray;
	};
}

export const timeblockGroupsAdapter = (groups) =>
	Object.entries(groups).map(([label, timeblocks]) => ({
		label,
		timeblocks: timeblocks.filter((tb) => typeof tb !== "undefined"),
	}));

export const getQuota = (timeblocks) =>
	timeblocks.reduce((acc, tb) => tb.availables + acc, 0);
